import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HorizonScan } from '../../../../../../core/models';

@Component({
  selector: 'dbx-admin-horizon-scan-option',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './admin-horizon-scan-option.component.html',
  styleUrl: './admin-horizon-scan-option.component.scss',
})
export class AdminHorizonScanOptionComponent {
  @Input({ required: true }) scan!: HorizonScan;
}
